import styled from 'styled-components';
import { isEmpty } from 'ts-utils';
import { Color } from '../../config/Color';

export const Spacer = styled.div<{ mobile?: number; space: number }>`
  height: ${({ space }) => space}px;
  @media ${({ theme }) => theme.device.mobile} {
    ${({ mobile }) => (mobile !== undefined ? `height: ${mobile}px` : '')};
  }
`;
export const Line = styled.hr<{ color?: string }>`
  border: none;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: ${({ color }) => (!isEmpty(color) ? color : 'black')};
  box-shadow: none;
`;

// Separator component for visual section dividers
export const Separator = styled.div<{ spacing?: string; color?: string; opacity?: number }>`
  border-top: 1px solid
    ${({ color, opacity }) => {
      if (opacity !== undefined) {
        return `rgba(255, 255, 255, ${opacity})`;
      }
      return color !== undefined && color !== '' ? color : Color.decorative.default;
    }};
  margin: ${({ spacing }) => (spacing !== undefined && spacing !== '' ? spacing : '24px 0')};
`;
